import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import milibooLogoWhiteUrl from '@/assets/logos/miliboo-logo-white.svg';
import i18n from '@/i18n';

type SupplierLayoutProps = {
  children: ReactNode;
};

export function SupplierLayout({ children }: SupplierLayoutProps) {
  //TODO remove this once the internationalization for the supplier is estabilished.
  const supplierI18n = useMemo(
    () =>
      i18n.cloneInstance({
        lng: 'en',
        fallbackLng: 'en',
      }),
    [],
  );

  return (
    <I18nextProvider i18n={supplierI18n}>
      <div className='min-h-screen bg-[#f6f5f3] text-foreground'>
        <header className='sticky top-0 z-50 bg-[#4d674d] text-white'>
          <div className='mx-auto flex w-full max-w-[1360px] items-center px-10 py-4'>
            <img
              alt='Miliboo'
              className='h-9 w-auto shrink-0 md:h-10'
              height={50}
              src={milibooLogoWhiteUrl}
              width={150}
            />
          </div>
        </header>

        <div className='mx-auto flex w-full max-w-[1360px] flex-col gap-10 px-10 py-14'>
          {children}
        </div>
      </div>
    </I18nextProvider>
  );
}
